import { Spinner } from "@climatepartner/components/Spinner";
import { ReactElement, ReactNode, Suspense } from "react";
import { Outlet } from "react-router-dom";

import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export {
  HubAcademyPage,
  HubContributionPage,
  HubHomePage,
  HubSolutionEmpcoPage,
  HubSolutionSbtiPage,
  HubSolutionScope3Page,
  preloadHubHomePage,
} from "./lazy-pages";

// Lazy: the providers pull in the MUI X date-picker stack and the hub's fetch client, which must
// not ride along in the entry bundle for users who never open a Homescreen route.
const HomescreenProviders = lazyWithChunkReload(() =>
  import("./homescreen-providers").then((m) => ({ default: m.HomescreenProviders }))
);

export const HubRoute = (): ReactElement => (
  <HubShell>
    <Outlet />
  </HubShell>
);

/**
 * Split out because the hub is entered two ways: `HubRoute` wraps `/academy` and
 * `/contribute`, while `HomeEntryRoute` renders the Homepage through this directly at `/`,
 * where there is no `Outlet`.
 */
export const HubShell = ({ children }: { children: ReactNode }): ReactElement => (
  <Suspense fallback={<Spinner />}>
    <HomescreenProviders>
      <Suspense fallback={<Spinner />}>{children}</Suspense>
    </HomescreenProviders>
  </Suspense>
);
